/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiOperation } from '../../models/AaiOperation';
import { Node } from '../../../core/models/Node';
import { Operation } from '../../../core/models/common/Operation';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} opType
 * @class
 * @extends AaiOperation
 * @author eric.wittmann@gmail.com
 */
export class Aai20Operation extends AaiOperation {
    public constructor(parent? : any, opType? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof opType === 'string') || opType === null)) {
            let __args = arguments;
            super(parent, opType);
        } else if(((typeof parent === 'string') || parent === null) && opType === undefined) {
            let __args = arguments;
            let opType : any = __args[0];
            super(opType);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && opType === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.AaiOperationBase#createTag()
     * @return {Aai20Tag}
     */
    public createTag() : Aai20Tag {
        return new Aai20Tag(this);
    }

    /**
     * @see Operation#createExternalDocumentation()
     * @return {Aai20ExternalDocumentation}
     */
    public createExternalDocumentation() : Aai20ExternalDocumentation {
        return new Aai20ExternalDocumentation(this);
    }
}
Aai20Operation["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Operation";
Aai20Operation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { Aai20ExternalDocumentation } from './Aai20ExternalDocumentation';


import { Aai20Tag } from './Aai20Tag';

